import style from './formSearch.scss';
import cns from 'classnames';
import React, { PureComponent } from 'react';
import { Form, Select, Spin } from 'antd';
import { paramFilter, isNotEmpty, isEmpty } from '../../../../utils/util';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import NoData from '../../../common/noData/NoData';
import CompanyAutoComplete from '../../../common/companyAutoComplete/CompanyAutoComplete';
import { sameCompanyContrast } from '../../../../services/financialPicture/baseInfo';
import { commonRequest } from '../../common/commons';
import { MARK_POINT_BASE64 } from '../../../../constants/common';
const FormItem = Form.Item;
const Option = Select.Option;

class FormSearch extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            companyCode: '',
            sameLoading: false,
            lineData: {},
            options: [
                { name: '净利润', value: 'netprofit' },
                { name: '营业收入增长率', value: 'bizincozzl' },
                { name: 'ROE', value: 'a20' },
                { name: '扣非净利润', value: 'npcut' },
                { name: '毛利率', value: 'grossrate' }
            ]
        };
    }

    getCompanyInfo = (selectedCompany) => {
        this.selectedCompany = selectedCompany;
    };

    resetCompanyInfo = (v) => {
        if (!this.selectedCompany || v !== this.selectedCompany.name) {
            this.selectedCompany = null;
        }
    };

    onSubmit = (e) => {
        e && e.preventDefault();

        const { validateFields } = this.props.form;
        validateFields({ force: true }, (err, values) => {
            if (!err) {
                // this.selectVal 下拉选择框的值
                this.selectVal = values.value;
                this.companyName = values.companyName; // 对比公司简称
                if (this.selectedCompany.code !== this.state.companyCode) {
                    this.sameCompanyPort({ comparecode: this.selectedCompany ? this.selectedCompany.code : { ...values } });
                } else {
                    this.setState({
                        lineData: this.commonFn()
                    });
                }
            }
        });
    };

    // 公司趋势对比
    sameCompanyPort = (params) => {
        this.setState({
            sameLoading: true
        });
        sameCompanyContrast(commonRequest(paramFilter(params))).then(data => {
            this.data = data || {};
            this.setState({
                companyCode: this.selectedCompany.code,
                lineData: this.commonFn(),
                sameLoading: false
            });
        }).catch(() => {
            this.setState({
                sameLoading: false
            });
        });
    };

    commonFn = () => {
        const { reportyear, sesname } = this.props.companyData;
        let val = this.selectVal, data = this.data, contrast = [], repalceContrast = [], 
            comparison = [], lineData = [], index, heightPoint;
        contrast = data['self' + val];
        comparison = data['compare' + val];
        lineData = [
            { name: '高位值', data: data['max' + val] },
            { name: '中位值', data: data['median' + val] },
            { name: '低位值', data: data['min' + val] }
        ];

        // 当data都为[]返回空对象
        if(isEmpty(data['max' + val]) && isEmpty(data['median' + val]) && isEmpty(data['min' + val])) {
            return {};
        }
        
        // 获取高亮坐标的位置和数据
        index = data.reportyear.findIndex((v) => v.substr(0, 4) === reportyear);
        heightPoint = {
            value: [index, contrast[index]],
            symbol: `image://${MARK_POINT_BASE64}`,
            symbolSize: [24, 104],
            symbolOffset: [0, 36]
        };
        contrast.forEach((item, i) => {
            i === index ? repalceContrast.push(heightPoint) : repalceContrast.push(item);
        });

        let storkName = this.companyName.substring(9, 13); // 对比公司简称
        return {
            color: ['#2365C4', '#73CDFC', '#F99248', '#FACD89', '#FF4545'],
            lineData: lineData,
            lineSymbolSize: 'none',
            category: data.reportyear,
            scatterData: [  // 散点图数据
                {name: sesname, data: repalceContrast},
                {name: storkName, data: comparison}
            ],
            scatterItemStyle: {
                normal: {
                    borderColor: '#fff',
                    borderWidth: 2
                }
            },
            grid: {
                top: 50,
                right: '4%'
            }
        };
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { sameLoading, options, lineData } = this.state;
        return (
            <div>
                <div className={cns('search-bar', style.formSearch)}>
                    <Form hideRequiredMark layout="inline" onSubmit={this.onSubmit}>
                        <FormItem>
                            {getFieldDecorator('value', {
                                rules: [{
                                    required: true, message: '请选择'
                                }],
                                initialValue: 'netprofit'
                            })(
                                <Select size="default">
                                    {options.map(item => <Option key={item.value} value={item.value}>{item.name}</Option>)}
                                </Select>
                            )}
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('companyName', {
                                rules: [{
                                    required: true, message: '请输入公司名称或代码'
                                }],
                                initialValue: ''
                            })(
                                <CompanyAutoComplete placeholder="请输入公司名称或代码" onChange={this.resetCompanyInfo} getCompanyInfo={this.getCompanyInfo} />
                            )}
                        </FormItem>
                        <button type="submit" className="btn btn-blue">搜索</button>
                    </Form>
                </div>
                <div className={cns(style.sameClassCP)}>
                    {sameLoading ? <Spin tip="数据加载中..." /> :
                        isNotEmpty(lineData) ? <BBDLineBar option={lineData} /> : <NoData />
                    }
                </div>
            </div>
        );
    }
}

export default (Form.create({})(FormSearch));



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/common/FormSearch.jsx